import axios from "axios";
import { API_URL, WEB_URL } from "../../constants";

export const ExchangeTokenApi = async (body,ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('USER_CODE');
    body.u_token = token; // Add the token to the request body
    try {
        let res = await axios.post(WEB_URL + 'fblogin/token',body, {
            headers: {
                'Authorization': ""
            },
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}